/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { Comment } from '@/wpt-lib/interfaces/Comment';
import SubHeading from '@/wpt-lib/pdf/common/SubHeading';
import { formatName } from '@/wpt-lib/utils/formatName';

const Comments = ({ comments }: { comments: Comment[] }) => {
    return comments.length > 0 ? (
        <>
            <Row>
                <SubHeading level={2} text="Comments" />
            </Row>
            {comments
                .sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
                .map((c, i) => (
                    <Row key={i} widths={[15, 15, 70]}>
                        <ValueCell label="Date" value={c.createdAt} format="date" />
                        <ValueCell label="Author" value={formatName(c.author?.user)} />
                        <ValueCell label="Comment" value={c.comment} />
                    </Row>
                ))}
        </>
    ) : null;
};

export default Comments;
